/** Live social proof for the landing page. Hides itself if numbers are too small to impress. */
import { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SocialProofStrip = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/stats`).then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return null;

  let line = null;
  if (stats.studying_this_week >= 5) {
    line = <><strong>{stats.studying_this_week} dentists</strong> studying this week{stats.questions_answered_this_week >= 100 && <> · <strong>{stats.questions_answered_this_week.toLocaleString()}</strong> questions answered</>}</>;
  } else if (stats.total_members >= 10) {
    line = <><strong>{stats.total_members} dentists</strong> already on board</>;
  }
  if (!line) return null;

  return (
    <div className="flex justify-center mt-6 animate-fade-in-up" data-testid="social-proof-strip">
      <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border bg-card text-sm text-muted-foreground">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-success opacity-60" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-success" />
        </span>
        <Users className="w-3.5 h-3.5" />
        <span>{line}</span>
      </div>
    </div>
  );
};

export default SocialProofStrip;
